import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
// import { Subscription } from 'rxjs/Subscription';

// import { Product } from '../products/product';

import { OrderConfirmationInfo } from './order-confirmation-info';
import { CartItem } from '../cart/cart-item';
export class OrderConfirmationService {
    orderConfirmationInfo: OrderConfirmationInfo = new OrderConfirmationInfo();
/**
 * @param {?} newOrderConfirmationInfo
 * @return {?}
 */
updateOrderConfirmationInfo(newOrderConfirmationInfo: OrderConfirmationInfo) {
        this.orderConfirmationInfo = newOrderConfirmationInfo;
    }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function OrderConfirmationService_tsickle_Closure_declarations() {
/** @type {?} */
OrderConfirmationService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OrderConfirmationService.ctorParameters;
/** @type {?} */
OrderConfirmationService.prototype.orderConfirmationInfo;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
